import React from "react";
import { ThemeProvider as SCThemeProvider } from "styled-components";
import { useSelector } from "react-redux";
import { getTheme } from "../../utils/colors";

const AppThemeProvider = ({ children }) => {
  const user = useSelector((state) => state.authReducer?.user);
  const tipo = user?.tipo || "pet"; // default pet (amarelo)
  const theme = getTheme(tipo);

  return <SCThemeProvider theme={theme}>{children}</SCThemeProvider>;
};

export default AppThemeProvider;
